import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const LANGS = [
  { code: "de", label: "DE", flag: "🇩🇪", dir: "ltr" },
  { code: "tr", label: "TR", flag: "🇹🇷", dir: "ltr" },
  { code: "ar", label: "AR", flag: "🇸🇦", dir: "rtl" },
  { code: "en", label: "EN", flag: "🇬🇧", dir: "ltr" },
  { code: "it", label: "IT", flag: "🇮🇹", dir: "ltr" },
  { code: "fr", label: "FR", flag: "🇫🇷", dir: "ltr" },
  { code: "es", label: "ES", flag: "🇪🇸", dir: "ltr" },
];

// Complete translation dictionary for all UI elements
const DICT = {
  de: { 
    bkSaveFavorite: "☆ Als Favorit speichern",
    bkSavedFavorite: "Als Favorit gespeichert",
    bkAvailableTimes: "Verfügbare Zeiten",
    loading: "Laden...",
    bkNoSlots: "Keine freien Termine an diesem Tag verfügbar",
    bkNotesOptional: "Anmerkungen (optional)",
    bkSubmitting: "Wird gebucht...",
    bkSubmitBooking: "Termin verbindlich buchen",
    bkConfirmationSent: "Eine Bestätigung wurde an {email} gesendet.",
    bkOClock: "Uhr",
    bkMinutes: "Minuten",
    coQuestionsContact: "Bei Fragen kontaktieren Sie bitte {name}.",
    toShop: "Zum Shop",
    plSigningIn: "Wird angemeldet...",
    coSuccessInfo: "Sie erhalten in Kürze eine Bestätigung per E-Mail.",
    coNotePlaceholder: "Optionale Anmerkungen...",
    bkStepOf: "Schritt {step} von {total}",
    bkMin: "Min",
    bkService: "Service:",
    bkDuration: "Dauer:",
    psAllPricesVat: "Alle Preise inkl. MwSt.",
    psBookAt: "Termin bei {name} buchen",
    psHeroCopy: "Wähle deine Leistung, deinen Wunsch-Stylisten und den passenden Zeitpunkt — bequem online in wenigen Klicks.",
    psStepChoose: "Termin\nwählen",
    psStepStylist: "Stylist\nauswählen",
    psStepConfirm: "Bestätigung\nerhalten",
    psAll: "Alle",
    psSummary: "Zusammenfassung",
    psUntilFreeShipping: "Noch {amount} bis zum kostenlosen Versand",
    coCheckoutTitle: "Kasse",
    coCardKlarna: "Kreditkarte, Klarna, etc.",
    coIAccept: "Ich akzeptiere die",
    coAnd: "und",
    coProcessing: "Wird verarbeitet...",
    coOrderNow: "Jetzt bestellen",
    toHome: "Zur Startseite",
    psFreeShippingFrom: "Kostenloser Versand ab 200,00 €",
    psAddedToCart: "In den Warenkorb gelegt!",
    bkToday: "Heute",
    bkSelectAll: "Bitte wählen Sie Service, Datum und Uhrzeit",
    fillRequired: "Bitte füllen Sie alle Pflichtfelder aus",
    fillAll: "Bitte füllen Sie alle Felder aus",
    bkBookedSuccess: "Termin erfolgreich gebucht!",
    firstName: "Vorname",
    lastName: "Nachname",
    deliveryAddress: "Lieferadresse",
    coDeliveryOptional: "Lieferadresse (optional)",
    zip: "PLZ",
    country: "Land",
    coCashOnDelivery: "Nachnahme / Barzahlung bei Abholung",
    coOnlinePayment: "Online-Zahlung",
    coOrderNote: "Anmerkung zur Bestellung",
    privacyPolicy: "Datenschutzerklärung",
    coAcceptTermsError: "Bitte akzeptieren Sie die AGB und Datenschutzerklärung",
    plLoginSuccess: "Anmeldung erfolgreich!",
    prCreateAccount: "Konto erstellen",
    prFasterOrders: "Schnellere Bestellung mit gespeicherten Daten",
    prPasswordMin8: "Passwort muss mindestens 8 Zeichen haben",
    prRegisterSuccess: "Registrierung erfolgreich!",
    psLogin: "Anmelden",
    psOnlineAppointment: "Online Termin",
    psBookNow: "Jetzt Termin buchen",
    psAvailableSlots: "Sofort verfügbare Slots",
    psBookAgain: "Jetzt erneut buchen",
    psNoProducts: "Keine Produkte verfügbar",
    psBackToShop: "Zurück zum Shop",
    psAddProducts: "Fügen Sie Produkte hinzu, um fortzufahren",
    psInclVat: "inkl. MwSt.",
    psBookAppointment: "Termin buchen",
    bkChooseService: "Wähle deine Leistung",
    bkAllOffers: "Alle Angebote auf einen Blick — einfach anklicken",
    bkChooseStaff: "Wählen Sie einen Mitarbeiter (optional)",
    bkNoPreference: "Keine Präferenz",
    bkNextAvailable: "Nächster verfügbarer Mitarbeiter",
    bkChooseDateTime: "Wählen Sie Datum und Uhrzeit",
    date: "Datum",
    time: "Uhrzeit",
    bkYourContact: "Ihre Kontaktdaten",
    bkBooked: "Termin gebucht!",
    bkDetails: "Termindetails",
    bkBookingNumber: "Buchungsnummer:",
    bkAddToCalendar: "Zum Kalender hinzufügen",
    bkQuestions: "Bei Fragen oder Änderungswünschen kontaktieren Sie bitte direkt den Shop.",
    bkNotAvailable: "Terminbuchung nicht verfügbar",
    bkNotOffered: "Dieser Shop bietet derzeit keine Online-Terminbuchung an.",
    bkBookingTitle: "Terminbuchung",
    bkYourSelection: "Ihre Auswahl",
    bkAcceptTerms: "Mit der Buchung akzeptieren Sie die AGB des Shops.",
    bkAnotherAppointment: "Weiteren Termin buchen",
    bkNotesPlaceholder: "Besondere Wünsche oder Hinweise...",
    coBackToCart: "Zurück zum Warenkorb",
    coContactData: "Kontaktdaten",
    coStreet: "Straße & Hausnummer *",
    coPayOnDelivery: "Zahlen Sie bei Lieferung oder Abholung",
    coThankYou: "Vielen Dank für Ihre Bestellung!",
    coOrderPlaced: "Ihre Bestellung wurde erfolgreich aufgegeben.",
    fpIntro: "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen.",
    fpSending: "Wird gesendet...",
    fpSendLink: "Link senden",
    fpEmailSent: "E-Mail gesendet!",
    fpIfAccount: "Wenn ein Konto mit",
    fpInfoRest: "existiert, erhalten Sie in Kürze eine E-Mail mit weiteren Anweisungen.",
    fpSpam: "Prüfen Sie auch Ihren Spam-Ordner, falls Sie keine E-Mail erhalten.",
    backToLogin: "Zurück zum Login",
    rpValidating: "Link wird überprüft...",
    rpLinkInvalid: "Link ungültig",
    rpRequestNew: "Neuen Link anfordern",
    rpChanged: "Passwort geändert!",
    rpChangedText: "Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können sich jetzt anmelden.",
    rpToLogin: "Zum Login",
    rpEnterNew: "Geben Sie Ihr neues Passwort ein.",
    rpMin8: "Mindestens 8 Zeichen",
    rpRepeat: "Passwort wiederholen",
    rpSaving: "Wird gespeichert...",
    rpSave: "Passwort speichern",
    forSms: "(für SMS)",
    registerWithGoogle: "Mit Google registrieren",
    plWelcomeBack: "Willkommen zurück",
    plRegisterNow: "Jetzt registrieren",
    plYourPassword: "Ihr Passwort",
    prOrderHistory: "Bestellhistorie und Terminübersicht",
    prStreet: "Straße und Hausnummer",
    status_new: "Neu",
    print: "Drucken",
    order: "Bestellung",
    paymentStatus: "Zahlungsstatus",
    loginWithGoogle: "Mit Google anmelden",
    or: "oder",
    forgotPassword: "Passwort vergessen?",
    productsFound: "{count} Produkte gefunden",
    details: "Details",
    free: "Kostenlos",
    pageOf: "Seite {page} von {total}",
    tryOtherSearch: "Versuchen Sie eine andere Suche.",
    productWorlds: "Panasonic Produktwelten",
    chooseWorld: "Wählen Sie Ihre Produktwelt, um das passende Sortiment zu entdecken",
    whyPanasonic: "Warum Panasonic?",
    qualityTitle: "Japanische Qualität",
    qualityText: "Höchste Fertigungsstandards und Langlebigkeit für den professionellen Einsatz",
    toolsTitle: "Professionelle Tools",
    toolsText: "Speziell entwickelt für die Anforderungen von Friseuren und Barbershops",
    techTitle: "Innovative Technik",
    techText: "Neueste Technologien für effizientes Arbeiten und beste Ergebnisse",
    discoverProducts: "Produkte entdecken",
    noShopYet: "Sie haben noch keinen Endkundenshop eingerichtet",
    noShopYetText: "Legen Sie Ihren White-Label-Shop an, um Panasonic-Produkte an eigene Endkunden zu verkaufen und Termine online zu vergeben.",
    setupShopNow: "Jetzt Shop einrichten →",
    chooseArea: "Wählen Sie den gewünschten Produktbereich aus.",
    openArea: "Produktbereich öffnen",
    originalWarranty: "Alle Panasonic-Produkte sind Original-Markenware mit Herstellergarantie.",
    backToWorlds: "Zurück zu Panasonic Produktwelten",
    backTo: "Zurück zu {name}",
    subcategories: "Unterkategorien",
    viewProducts: "Produkte ansehen",
    productsInCategory: "Produkte in dieser Kategorie",
    clickToViewProducts: "Klicken Sie hier, um alle Produkte in \"{name}\" anzuzeigen.",
    showProducts: "Produkte anzeigen",
    noCategories: "Keine Kategorien verfügbar.",
    searchProduct: "Produkt suchen...",
    back: "Zurück",
    next: "Weiter",
    allCategories: "Alle Kategorien",
    searchProducts: "Produkte suchen...",
    showMoreProducts: "Weitere Produkte anzeigen",
    shownOfProducts: "{shown} von {total} Produkten angezeigt",
    orderedItems: "Bestellte Artikel",
    orderNotFound: "Bestellung nicht gefunden",
    b2bTagline: "B2B Großhandel für Barbershops und Friseursalons",
    customerService: "Kundenservice",
    noNewNotifications: "Keine neuen Benachrichtigungen",
    viewPublicShop: "Öffentlichen Shop ansehen",
    manageShop: "Mein Endkundenshop verwalten",
    noProductsInCategory: "In dieser Kategorie sind noch keine Produkte verfügbar.",
    home: "Startseite", 
    shop: "Shop", 
    cart: "Warenkorb", 
    favorites: "Favoriten", 
    profile: "Profil",
    orders: "Bestellungen",
    admin: "Admin",
    logout: "Abmelden",
    login: "Anmelden",
    register: "Registrieren",
    products: "Produkte",
    addToCart: "In den Warenkorb",
    loading: "Wird geladen...",
    noProducts: "Keine Produkte gefunden",
    addedToFavorites: "Zu Favoriten hinzugefügt",
    removedFromFavorites: "Aus Favoriten entfernt",
    addedToCart: "Produkt zum Warenkorb hinzugefügt",
    errorLoadingProducts: "Fehler beim Laden der Produkte",
    errorUpdatingFavorites: "Fehler beim Aktualisieren der Favoriten",
    welcomeBack: "Willkommen zurück zu ED STEEL",
    email: "E-Mail",
    password: "Passwort",
    noAccount: "Noch kein Konto?",
    checkout: "Zur Kasse",
    total: "Gesamt",
    shipping: "Versand",
    freeShipping: "Kostenloser Versand",
    freeShippingFrom: "Kostenloser Versand ab €200",
    remainingForFreeShipping: "Noch {amount} bis zum kostenlosen Versand",
    emptyCart: "Ihr Warenkorb ist leer",
    continueShopping: "Weiter einkaufen",
    orderConfirmation: "Bestellbestätigung",
    orderPlaced: "Ihre Bestellung wurde aufgegeben",
    payOnDelivery: "Nachnahme",
    onlinePayment: "Online bezahlen",
    placeOrder: "Bestellung aufgeben",
    quantity: "Menge",
    price: "Preis",
    priceNet: "Netto",
    priceGross: "Brutto",
    artNr: "Art.-Nr.",
    remove: "Entfernen",
    search: "Suchen",
    categories: "Kategorien",
    allProducts: "Alle Produkte",
    bestsellers: "Bestseller",
    newArrivals: "Neuheiten",
    description: "Beschreibung",
    inStock: "Auf Lager",
    outOfStock: "Nicht verfügbar",
    orderHistory: "Bestellverlauf",
    orderNumber: "Bestellnummer",
    orderDate: "Bestelldatum",
    orderStatus: "Status",
    downloadPdf: "PDF herunterladen",
    editAddress: "Adresse bearbeiten",
    changePassword: "Passwort ändern",
    save: "Speichern",
    cancel: "Abbrechen",
    status_received: "Eingegangen",
    status_in_progress: "In Bearbeitung",
    status_shipped: "Versendet",
    status_delivered: "Geliefert",
    companyName: "Firmenname",
    contactName: "Ansprechpartner",
    phone: "Telefon",
    address: "Adresse",
    city: "Stadt",
    postalCode: "PLZ",
    // New keys for translated pages
    noFavorites: "Keine Favoriten vorhanden",
    goToShop: "Zum Shop",
    errorLoadingFavorites: "Fehler beim Laden der Favoriten",
    error: "Fehler",
    noOrders: "Keine Bestellungen vorhanden",
    paid: "Bezahlt",
    pending: "Ausstehend",
    downloadInvoice: "Rechnung herunterladen",
    downloadConfirmation: "Bestätigung herunterladen",
    shippingAddress: "Lieferadresse",
    paymentMethod: "Zahlungsmethode",
    notes: "Anmerkungen",
    notesPlaceholder: "z.B. Bitte morgen liefern",
    orderViaWhatsApp: "Bestellung per WhatsApp senden",
    orderSummary: "Bestellübersicht",
    subtotal: "Zwischensumme",
    processing: "Wird verarbeitet...",
    orderSuccess: "Bestellung erfolgreich aufgegeben",
    orderFailed: "Bestellung fehlgeschlagen",
    heroBanner: "PROFI-PRODUKTE. SCHNELL BESTELLT. – Exklusiv für B2B-Kunden im Barbershop-Bereich.",
    errorLoadingCategories: "Fehler beim Laden der Kategorien",
    contact: "Kontakt",
    imprint: "Impressum",
    privacy: "Datenschutz",
    terms: "AGB",
    cancellation: "Widerruf",
    shippingPayment: "Versand & Zahlung",
    allRightsReserved: "Alle Rechte vorbehalten.",
    // Login/Register keys
    loginSuccess: "Login erfolgreich",
    loginFailed: "Login fehlgeschlagen. Bitte überprüfen Sie Ihre Daten.",
    registerSuccess: "Registrierung erfolgreich",
    registerFailed: "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    createAccount: "Erstellen Sie Ihr ED STEEL Konto",
    haveAccount: "Haben Sie bereits ein Konto?",
    productNotFound: "Produkt nicht gefunden",
    downloadFailed: "Download fehlgeschlagen",
    downloadStarted: "Download gestartet",
    downloadOrder: "Bestellung herunterladen",
    // Profile page keys
    b2bOnly: "Nur für Gewerbetreibende (B2B)",
    addressAndContact: "Adresse & Kontakt",
    edit: "Bearbeiten",
    saving: "Speichern...",
    profileUpdated: "Profil erfolgreich aktualisiert",
    errorSaving: "Fehler beim Speichern",
    passwordSection: "Passwort",
    change: "Ändern",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmPassword: "Neues Passwort bestätigen",
    passwordsNotMatch: "Passwörter stimmen nicht überein",
    passwordTooShort: "Passwort muss mindestens 6 Zeichen lang sein",
    passwordChanged: "Passwort erfolgreich geändert",
    errorChangingPassword: "Fehler beim Ändern des Passworts",
    viewOrderHistory: "Bestellhistorie ansehen",
    savedProducts: "Gespeicherte Produkte",
    legalSection: "Rechtliches"
  },
  tr: { 
    bkSaveFavorite: "☆ Favori olarak kaydet",
    bkSavedFavorite: "Favori olarak kaydedildi",
    bkAvailableTimes: "Uygun saatler",
    loading: "Yükleniyor...",
    bkNoSlots: "Bu gün için uygun randevu yok",
    bkNotesOptional: "Notlar (isteğe bağlı)",
    bkSubmitting: "Randevu alınıyor...",
    bkSubmitBooking: "Randevuyu kesin olarak al",
    bkConfirmationSent: "{email} adresine bir onay gönderildi.",
    bkOClock: "",
    bkMinutes: "dakika",
    coQuestionsContact: "Sorularınız için lütfen {name} ile iletişime geçin.",
    toShop: "Mağazaya git",
    plSigningIn: "Giriş yapılıyor...",
    toHome: "Ana sayfaya git",
    psFreeShippingFrom: "200,00 € üzeri ücretsiz kargo",
    psAddedToCart: "Sepete eklendi!",
    bkToday: "Bugün",
    bkSelectAll: "Lütfen hizmet, tarih ve saat seçin",
    fillRequired: "Lütfen tüm zorunlu alanları doldurun",
    fillAll: "Lütfen tüm alanları doldurun",
    bkBookedSuccess: "Randevu başarıyla alındı!",
    firstName: "Ad",
    lastName: "Soyad",
    deliveryAddress: "Teslimat adresi",
    coDeliveryOptional: "Teslimat adresi (isteğe bağlı)",
    zip: "Posta kodu",
    country: "Ülke",
    coCashOnDelivery: "Kapıda ödeme / Teslim alırken nakit",
    coOnlinePayment: "Online ödeme",
    coOrderNote: "Sipariş notu",
    privacyPolicy: "Gizlilik politikası",
    coAcceptTermsError: "Lütfen şartları ve gizlilik politikasını kabul edin",
    plLoginSuccess: "Giriş başarılı!",
    prCreateAccount: "Hesap oluştur",
    prFasterOrders: "Kayıtlı bilgilerle daha hızlı sipariş",
    prPasswordMin8: "Şifre en az 8 karakter olmalı",
    prRegisterSuccess: "Kayıt başarılı!",
    coSuccessInfo: "Kısa süre içinde e-posta ile onay alacaksınız.",
    coNotePlaceholder: "İsteğe bağlı notlar...",
    bkStepOf: "Adım {step} / {total}",
    bkMin: "dk",
    bkService: "Hizmet:",
    bkDuration: "Süre:",
    psAllPricesVat: "Tüm fiyatlara KDV dahildir.",
    psBookAt: "{name} için randevu al",
    psHeroCopy: "Hizmetini, istediğin stilisti ve uygun zamanı seç — birkaç tıklamayla kolayca online.",
    psStepChoose: "Randevu\nseç",
    psStepStylist: "Stilist\nseç",
    psStepConfirm: "Onay\nal",
    psAll: "Tümü",
    psSummary: "Özet",
    psUntilFreeShipping: "Ücretsiz kargoya {amount} kaldı",
    coCheckoutTitle: "Kasa",
    coCardKlarna: "Kredi kartı, Klarna vb.",
    coIAccept: "Kabul ediyorum:",
    coAnd: "ve",
    coProcessing: "İşleniyor...",
    coOrderNow: "Şimdi sipariş ver",
    psLogin: "Giriş yap",
    psOnlineAppointment: "Online randevu",
    psBookNow: "Hemen randevu al",
    psAvailableSlots: "Hemen uygun saatler",
    psBookAgain: "Tekrar randevu al",
    psNoProducts: "Ürün bulunmuyor",
    psBackToShop: "Mağazaya geri dön",
    psAddProducts: "Devam etmek için ürün ekleyin",
    psInclVat: "KDV dahil",
    psBookAppointment: "Randevu al",
    bkChooseService: "Hizmetini seç",
    bkAllOffers: "Tüm hizmetler bir bakışta — tıklamanız yeterli",
    bkChooseStaff: "Bir çalışan seçin (isteğe bağlı)",
    bkNoPreference: "Fark etmez",
    bkNextAvailable: "Bir sonraki uygun çalışan",
    bkChooseDateTime: "Tarih ve saat seçin",
    date: "Tarih",
    time: "Saat",
    bkYourContact: "İletişim bilgileriniz",
    bkBooked: "Randevu alındı!",
    bkDetails: "Randevu detayları",
    bkBookingNumber: "Rezervasyon numarası:",
    bkAddToCalendar: "Takvime ekle",
    bkQuestions: "Sorularınız veya değişiklikler için lütfen doğrudan mağazayla iletişime geçin.",
    bkNotAvailable: "Randevu alma kullanılamıyor",
    bkNotOffered: "Bu mağaza şu anda online randevu sunmuyor.",
    bkBookingTitle: "Randevu",
    bkYourSelection: "Seçiminiz",
    bkAcceptTerms: "Rezervasyon ile mağazanın şartlarını kabul etmiş olursunuz.",
    bkAnotherAppointment: "Başka bir randevu al",
    bkNotesPlaceholder: "Özel istekler veya notlar...",
    coBackToCart: "Sepete geri dön",
    coContactData: "İletişim bilgileri",
    coStreet: "Cadde ve bina no *",
    coPayOnDelivery: "Teslimatta veya alımda ödeyin",
    coThankYou: "Siparişiniz için teşekkürler!",
    coOrderPlaced: "Siparişiniz başarıyla oluşturuldu.",
    fpIntro: "E-posta adresinizi girin, size sıfırlama bağlantısı gönderelim.",
    fpSending: "Gönderiliyor...",
    fpSendLink: "Bağlantı gönder",
    fpEmailSent: "E-posta gönderildi!",
    fpIfAccount: "Eğer",
    fpInfoRest: "ile bir hesap varsa, kısa süre içinde talimat içeren bir e-posta alacaksınız.",
    fpSpam: "E-posta almazsanız spam klasörünüzü de kontrol edin.",
    backToLogin: "Girişe geri dön",
    rpValidating: "Bağlantı kontrol ediliyor...",
    rpLinkInvalid: "Geçersiz bağlantı",
    rpRequestNew: "Yeni bağlantı iste",
    rpChanged: "Şifre değiştirildi!",
    rpChangedText: "Şifreniz başarıyla sıfırlandı. Şimdi giriş yapabilirsiniz.",
    rpToLogin: "Girişe git",
    rpEnterNew: "Yeni şifrenizi girin.",
    rpMin8: "En az 8 karakter",
    rpRepeat: "Şifreyi tekrarla",
    rpSaving: "Kaydediliyor...",
    rpSave: "Şifreyi kaydet",
    forSms: "(SMS için)",
    registerWithGoogle: "Google ile kayıt ol",
    plWelcomeBack: "Tekrar hoş geldiniz",
    plRegisterNow: "Şimdi kayıt ol",
    plYourPassword: "Şifreniz",
    prOrderHistory: "Sipariş geçmişi ve randevu özeti",
    prStreet: "Cadde ve bina numarası",
    status_new: "Yeni",
    print: "Yazdır",
    order: "Sipariş",
    paymentStatus: "Ödeme durumu",
    loginWithGoogle: "Google ile giriş yap",
    or: "veya",
    forgotPassword: "Şifrenizi mi unuttunuz?",
    productsFound: "{count} ürün bulundu",
    details: "Detaylar",
    free: "Ücretsiz",
    pageOf: "Sayfa {page} / {total}",
    tryOtherSearch: "Farklı bir arama deneyin.",
    productWorlds: "Panasonic Ürün Dünyaları",
    chooseWorld: "Uygun ürün yelpazesini keşfetmek için ürün dünyanızı seçin",
    whyPanasonic: "Neden Panasonic?",
    qualityTitle: "Japon Kalitesi",
    qualityText: "Profesyonel kullanım için en yüksek üretim standartları ve dayanıklılık",
    toolsTitle: "Profesyonel Aletler",
    toolsText: "Kuaförlerin ve berber dükkanlarının ihtiyaçları için özel olarak geliştirilmiştir",
    techTitle: "Yenilikçi Teknoloji",
    techText: "Verimli çalışma ve en iyi sonuçlar için en yeni teknolojiler",
    discoverProducts: "Ürünleri keşfet",
    noShopYet: "Henüz bir müşteri mağazası kurmadınız",
    noShopYetText: "Panasonic ürünlerini kendi müşterilerinize satmak ve online randevu vermek için white-label mağazanızı oluşturun.",
    setupShopNow: "Şimdi mağaza kur →",
    chooseArea: "İstediğiniz ürün alanını seçin.",
    openArea: "Ürün alanını aç",
    originalWarranty: "Tüm Panasonic ürünleri üretici garantili orijinal markalı ürünlerdir.",
    backToWorlds: "Panasonic Ürün Dünyalarına geri dön",
    backTo: "{name} sayfasına geri dön",
    subcategories: "Alt kategoriler",
    viewProducts: "Ürünleri görüntüle",
    productsInCategory: "Bu kategorideki ürünler",
    clickToViewProducts: "\"{name}\" içindeki tüm ürünleri görmek için buraya tıklayın.",
    showProducts: "Ürünleri göster",
    noCategories: "Kategori bulunmuyor.",
    searchProduct: "Ürün ara...",
    back: "Geri",
    next: "İleri",
    allCategories: "Tüm kategoriler",
    searchProducts: "Ürün ara...",
    showMoreProducts: "Daha fazla ürün göster",
    shownOfProducts: "{total} üründen {shown} tanesi gösteriliyor",
    orderedItems: "Sipariş edilen ürünler",
    orderNotFound: "Sipariş bulunamadı",
    b2bTagline: "Berber dükkanları ve kuaför salonları için B2B toptan satış",
    customerService: "Müşteri hizmetleri",
    noNewNotifications: "Yeni bildirim yok",
    viewPublicShop: "Herkese açık mağazayı görüntüle",
    manageShop: "Müşteri mağazamı yönet",
    noProductsInCategory: "Bu kategoride henüz ürün bulunmamaktadır.",
    home: "Ana Sayfa", 
    shop: "Mağaza", 
    cart: "Sepet", 
    favorites: "Favoriler", 
    profile: "Profil",
    orders: "Siparişler",
    admin: "Yönetici",
    logout: "Çıkış",
    login: "Giriş",
    register: "Kayıt Ol",
    products: "Ürünler",
    addToCart: "Sepete Ekle",
    loading: "Yükleniyor...",
    noProducts: "Ürün bulunamadı",
    addedToFavorites: "Favorilere eklendi",
    removedFromFavorites: "Favorilerden kaldırıldı",
    addedToCart: "Ürün sepete eklendi",
    errorLoadingProducts: "Ürünler yüklenirken hata oluştu",
    errorUpdatingFavorites: "Favoriler güncellenirken hata oluştu",
    welcomeBack: "ED STEEL'e tekrar hoş geldiniz",
    email: "E-posta",
    password: "Şifre",
    noAccount: "Hesabınız yok mu?",
    checkout: "Ödemeye Git",
    total: "Toplam",
    shipping: "Kargo",
    freeShipping: "Ücretsiz Kargo",
    freeShippingFrom: "200€ üzeri ücretsiz kargo",
    remainingForFreeShipping: "Ücretsiz kargoya {amount} kaldı",
    emptyCart: "Sepetiniz boş",
    continueShopping: "Alışverişe devam",
    orderConfirmation: "Sipariş Onayı",
    orderPlaced: "Siparişiniz alındı",
    payOnDelivery: "Kapıda Ödeme",
    onlinePayment: "Online Ödeme",
    placeOrder: "Sipariş Ver",
    quantity: "Adet",
    price: "Fiyat",
    priceNet: "Net",
    priceGross: "Brüt",
    artNr: "Art.-Nr.",
    remove: "Kaldır",
    search: "Ara",
    categories: "Kategoriler",
    allProducts: "Tüm Ürünler",
    bestsellers: "Çok Satanlar",
    newArrivals: "Yeni Gelenler",
    description: "Açıklama",
    inStock: "Stokta",
    outOfStock: "Stokta yok",
    orderHistory: "Sipariş Geçmişi",
    orderNumber: "Sipariş No",
    orderDate: "Sipariş Tarihi",
    orderStatus: "Durum",
    downloadPdf: "PDF İndir",
    editAddress: "Adresi Düzenle",
    changePassword: "Şifre Değiştir",
    save: "Kaydet",
    cancel: "İptal",
    status_received: "Alındı",
    status_in_progress: "Hazırlanıyor",
    status_shipped: "Kargoya verildi",
    status_delivered: "Teslim edildi",
    companyName: "Şirket Adı",
    contactName: "İletişim Kişisi",
    phone: "Telefon",
    address: "Adres",
    city: "Şehir",
    postalCode: "Posta Kodu",
    // New keys for translated pages
    noFavorites: "Favori yok",
    goToShop: "Mağazaya Git",
    errorLoadingFavorites: "Favoriler yüklenirken hata",
    error: "Hata",
    noOrders: "Sipariş yok",
    paid: "Ödendi",
    pending: "Beklemede",
    downloadInvoice: "Fatura İndir",
    downloadConfirmation: "Onay İndir",
    shippingAddress: "Teslimat Adresi",
    paymentMethod: "Ödeme Yöntemi",
    notes: "Notlar",
    notesPlaceholder: "Örn: Yarın teslim edin",
    orderViaWhatsApp: "WhatsApp ile Sipariş Ver",
    orderSummary: "Sipariş Özeti",
    subtotal: "Ara Toplam",
    processing: "İşleniyor...",
    orderSuccess: "Sipariş başarıyla oluşturuldu",
    orderFailed: "Sipariş başarısız",
    heroBanner: "PROFESİYONEL ÜRÜNLER. HIZLI SİPARİŞ. – Berber sektöründeki B2B müşterilerine özel.",
    errorLoadingCategories: "Kategoriler yüklenirken hata",
    contact: "İletişim",
    imprint: "Künye",
    privacy: "Gizlilik",
    terms: "Şartlar",
    cancellation: "İptal",
    shippingPayment: "Kargo & Ödeme",
    allRightsReserved: "Tüm hakları saklıdır.",
    // Login/Register keys
    loginSuccess: "Giriş başarılı",
    loginFailed: "Giriş başarısız. Lütfen bilgilerinizi kontrol edin.",
    registerSuccess: "Kayıt başarılı",
    registerFailed: "Kayıt başarısız. Lütfen tekrar deneyin.",
    createAccount: "ED STEEL hesabınızı oluşturun",
    haveAccount: "Zaten hesabınız var mı?",
    productNotFound: "Ürün bulunamadı",
    downloadFailed: "İndirme başarısız",
    downloadStarted: "İndirme başladı",
    downloadOrder: "Siparişi indir",
    // Profile page keys
    b2bOnly: "Sadece B2B müşterileri için",
    addressAndContact: "Adres & İletişim",
    edit: "Düzenle",
    saving: "Kaydediliyor...",
    profileUpdated: "Profil başarıyla güncellendi",
    errorSaving: "Kaydetme hatası",
    passwordSection: "Şifre",
    change: "Değiştir",
    currentPassword: "Mevcut Şifre",
    newPassword: "Yeni Şifre",
    confirmPassword: "Yeni Şifreyi Onayla",
    passwordsNotMatch: "Şifreler eşleşmiyor",
    passwordTooShort: "Şifre en az 6 karakter olmalı",
    passwordChanged: "Şifre başarıyla değiştirildi",
    errorChangingPassword: "Şifre değiştirme hatası",
    viewOrderHistory: "Sipariş geçmişini görüntüle",
    savedProducts: "Kayıtlı ürünler",
    legalSection: "Yasal"
  },
  ar: { 
    bkSaveFavorite: "☆ حفظ كمفضلة",
    bkSavedFavorite: "تم الحفظ كمفضلة",
    bkAvailableTimes: "الأوقات المتاحة",
    loading: "جارٍ التحميل...",
    bkNoSlots: "لا توجد مواعيد متاحة في هذا اليوم",
    bkNotesOptional: "ملاحظات (اختياري)",
    bkSubmitting: "جارٍ الحجز...",
    bkSubmitBooking: "تأكيد حجز الموعد",
    bkConfirmationSent: "تم إرسال تأكيد إلى {email}.",
    bkOClock: "",
    bkMinutes: "دقيقة",
    coQuestionsContact: "لأي استفسارات، يرجى التواصل مع {name}.",
    toShop: "إلى المتجر",
    plSigningIn: "جارٍ تسجيل الدخول...",
    toHome: "إلى الصفحة الرئيسية",
    psFreeShippingFrom: "شحن مجاني للطلبات فوق 200,00 €",
    psAddedToCart: "تمت الإضافة إلى السلة!",
    bkToday: "اليوم",
    bkSelectAll: "يرجى اختيار الخدمة والتاريخ والوقت",
    fillRequired: "يرجى ملء جميع الحقول المطلوبة",
    fillAll: "يرجى ملء جميع الحقول",
    bkBookedSuccess: "تم حجز الموعد بنجاح!",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    deliveryAddress: "عنوان التسليم",
    coDeliveryOptional: "عنوان التسليم (اختياري)",
    zip: "الرمز البريدي",
    country: "الدولة",
    coCashOnDelivery: "الدفع عند الاستلام / نقدًا عند الاستلام",
    coOnlinePayment: "الدفع عبر الإنترنت",
    coOrderNote: "ملاحظة على الطلب",
    privacyPolicy: "سياسة الخصوصية",
    coAcceptTermsError: "يرجى الموافقة على الشروط وسياسة الخصوصية",
    plLoginSuccess: "تم تسجيل الدخول بنجاح!",
    prCreateAccount: "إنشاء حساب",
    prFasterOrders: "طلب أسرع مع البيانات المحفوظة",
    prPasswordMin8: "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
    prRegisterSuccess: "تم التسجيل بنجاح!",
    coSuccessInfo: "ستتلقى قريبًا تأكيدًا عبر البريد الإلكتروني.",
    coNotePlaceholder: "ملاحظات اختيارية...",
    bkStepOf: "الخطوة {step} من {total}",
    bkMin: "دقيقة",
    bkService: "الخدمة:",
    bkDuration: "المدة:",
    psAllPricesVat: "جميع الأسعار شاملة الضريبة.",
    psBookAt: "احجز موعدًا لدى {name}",
    psHeroCopy: "اختر الخدمة والمصفف والوقت المناسب — بسهولة عبر الإنترنت بنقرات قليلة.",
    psStepChoose: "اختر\nالموعد",
    psStepStylist: "اختر\nالمصفف",
    psStepConfirm: "استلم\nالتأكيد",
    psAll: "الكل",
    psSummary: "الملخص",
    psUntilFreeShipping: "يتبقى {amount} للشحن المجاني",
    coCheckoutTitle: "الدفع",
    coCardKlarna: "بطاقة ائتمان، Klarna، إلخ.",
    coIAccept: "أوافق على",
    coAnd: "و",
    coProcessing: "جارٍ المعالجة...",
    coOrderNow: "اطلب الآن",
    psLogin: "تسجيل الدخول",
    psOnlineAppointment: "موعد عبر الإنترنت",
    psBookNow: "احجز موعدًا الآن",
    psAvailableSlots: "مواعيد متاحة فورًا",
    psBookAgain: "احجز مرة أخرى",
    psNoProducts: "لا توجد منتجات متاحة",
    psBackToShop: "العودة إلى المتجر",
    psAddProducts: "أضف منتجات للمتابعة",
    psInclVat: "شامل الضريبة",
    psBookAppointment: "حجز موعد",
    bkChooseService: "اختر الخدمة",
    bkAllOffers: "جميع العروض في لمحة — انقر فقط",
    bkChooseStaff: "اختر موظفًا (اختياري)",
    bkNoPreference: "لا تفضيل",
    bkNextAvailable: "أول موظف متاح",
    bkChooseDateTime: "اختر التاريخ والوقت",
    date: "التاريخ",
    time: "الوقت",
    bkYourContact: "بيانات الاتصال الخاصة بك",
    bkBooked: "تم حجز الموعد!",
    bkDetails: "تفاصيل الموعد",
    bkBookingNumber: "رقم الحجز:",
    bkAddToCalendar: "أضف إلى التقويم",
    bkQuestions: "للاستفسارات أو التغييرات، يرجى التواصل مع المتجر مباشرة.",
    bkNotAvailable: "حجز المواعيد غير متاح",
    bkNotOffered: "هذا المتجر لا يقدم حاليًا حجزًا عبر الإنترنت.",
    bkBookingTitle: "حجز موعد",
    bkYourSelection: "اختيارك",
    bkAcceptTerms: "بالحجز فإنك توافق على شروط المتجر.",
    bkAnotherAppointment: "حجز موعد آخر",
    bkNotesPlaceholder: "طلبات أو ملاحظات خاصة...",
    coBackToCart: "العودة إلى السلة",
    coContactData: "بيانات الاتصال",
    coStreet: "الشارع ورقم المنزل *",
    coPayOnDelivery: "ادفع عند التسليم أو الاستلام",
    coThankYou: "شكرًا لطلبك!",
    coOrderPlaced: "تم تقديم طلبك بنجاح.",
    fpIntro: "أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين.",
    fpSending: "جارٍ الإرسال...",
    fpSendLink: "إرسال الرابط",
    fpEmailSent: "تم إرسال البريد!",
    fpIfAccount: "إذا كان هناك حساب بالبريد",
    fpInfoRest: "موجود، فستتلقى قريبًا بريدًا يحتوي على مزيد من التعليمات.",
    fpSpam: "تحقق أيضًا من مجلد الرسائل غير المرغوب فيها.",
    backToLogin: "العودة لتسجيل الدخول",
    rpValidating: "جارٍ التحقق من الرابط...",
    rpLinkInvalid: "الرابط غير صالح",
    rpRequestNew: "طلب رابط جديد",
    rpChanged: "تم تغيير كلمة المرور!",
    rpChangedText: "تمت إعادة تعيين كلمة المرور بنجاح. يمكنك تسجيل الدخول الآن.",
    rpToLogin: "إلى تسجيل الدخول",
    rpEnterNew: "أدخل كلمة المرور الجديدة.",
    rpMin8: "8 أحرف على الأقل",
    rpRepeat: "كرر كلمة المرور",
    rpSaving: "جارٍ الحفظ...",
    rpSave: "حفظ كلمة المرور",
    forSms: "(للرسائل النصية)",
    registerWithGoogle: "التسجيل عبر Google",
    plWelcomeBack: "مرحبًا بعودتك",
    plRegisterNow: "سجّل الآن",
    plYourPassword: "كلمة المرور الخاصة بك",
    prOrderHistory: "سجل الطلبات وملخص المواعيد",
    prStreet: "الشارع ورقم المنزل",
    status_new: "جديد",
    print: "طباعة",
    order: "الطلب",
    paymentStatus: "حالة الدفع",
    loginWithGoogle: "تسجيل الدخول عبر Google",
    or: "أو",
    forgotPassword: "هل نسيت كلمة المرور؟",
    productsFound: "تم العثور على {count} منتج",
    details: "التفاصيل",
    free: "مجاني",
    pageOf: "صفحة {page} من {total}",
    tryOtherSearch: "جرّب بحثًا آخر.",
    productWorlds: "عوالم منتجات باناسونيك",
    chooseWorld: "اختر عالم المنتجات الخاص بك لاكتشاف التشكيلة المناسبة",
    whyPanasonic: "لماذا باناسونيك؟",
    qualityTitle: "جودة يابانية",
    qualityText: "أعلى معايير التصنيع والمتانة للاستخدام الاحترافي",
    toolsTitle: "أدوات احترافية",
    toolsText: "مطوّرة خصيصًا لاحتياجات الحلاقين وصالونات الحلاقة",
    techTitle: "تقنية مبتكرة",
    techText: "أحدث التقنيات للعمل الفعّال وأفضل النتائج",
    discoverProducts: "اكتشف المنتجات",
    noShopYet: "لم تقم بإنشاء متجر للعملاء بعد",
    noShopYetText: "أنشئ متجرك ذا العلامة البيضاء لبيع منتجات باناسونيك لعملائك وتقديم المواعيد عبر الإنترنت.",
    setupShopNow: "أنشئ المتجر الآن ←",
    chooseArea: "اختر مجال المنتجات الذي تريده.",
    openArea: "فتح مجال المنتجات",
    originalWarranty: "جميع منتجات باناسونيك أصلية وتشمل ضمان الشركة المصنعة.",
    backToWorlds: "العودة إلى عوالم منتجات باناسونيك",
    backTo: "العودة إلى {name}",
    subcategories: "الفئات الفرعية",
    viewProducts: "عرض المنتجات",
    productsInCategory: "المنتجات في هذه الفئة",
    clickToViewProducts: "انقر هنا لعرض جميع المنتجات في \"{name}\".",
    showProducts: "عرض المنتجات",
    noCategories: "لا توجد فئات متاحة.",
    searchProduct: "ابحث عن منتج...",
    back: "رجوع",
    next: "التالي",
    allCategories: "جميع الفئات",
    searchProducts: "ابحث عن منتجات...",
    showMoreProducts: "عرض المزيد من المنتجات",
    shownOfProducts: "يتم عرض {shown} من {total} منتج",
    orderedItems: "المنتجات المطلوبة",
    orderNotFound: "الطلب غير موجود",
    b2bTagline: "بيع بالجملة B2B لصالونات الحلاقة",
    customerService: "خدمة العملاء",
    noNewNotifications: "لا توجد إشعارات جديدة",
    viewPublicShop: "عرض المتجر العام",
    manageShop: "إدارة متجر عملائي",
    noProductsInCategory: "لا توجد منتجات متاحة في هذه الفئة بعد.",
    home: "الرئيسية", 
    shop: "المتجر", 
    cart: "السلة", 
    favorites: "المفضلة", 
    profile: "الملف الشخصي",
    orders: "الطلبات",
    admin: "الإدارة",
    logout: "تسجيل خروج",
    login: "تسجيل دخول",
    register: "تسجيل",
    products: "المنتجات",
    addToCart: "أضف للسلة",
    loading: "جاري التحميل...",
    noProducts: "لا توجد منتجات",
    addedToFavorites: "تمت الإضافة للمفضلة",
    removedFromFavorites: "تمت الإزالة من المفضلة",
    addedToCart: "تمت الإضافة للسلة",
    errorLoadingProducts: "خطأ في تحميل المنتجات",
    errorUpdatingFavorites: "خطأ في تحديث المفضلة",
    welcomeBack: "مرحباً بك في ED STEEL",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    noAccount: "ليس لديك حساب؟",
    checkout: "الدفع",
    total: "المجموع",
    shipping: "الشحن",
    freeShipping: "شحن مجاني",
    freeShippingFrom: "شحن مجاني للطلبات فوق 200€",
    remainingForFreeShipping: "باقي {amount} للشحن المجاني",
    emptyCart: "السلة فارغة",
    continueShopping: "متابعة التسوق",
    orderConfirmation: "تأكيد الطلب",
    orderPlaced: "تم تقديم طلبك",
    payOnDelivery: "الدفع عند الاستلام",
    onlinePayment: "دفع إلكتروني",
    placeOrder: "تأكيد الطلب",
    quantity: "الكمية",
    price: "السعر",
    priceNet: "صافي",
    priceGross: "إجمالي",
    artNr: "رقم المنتج",
    remove: "إزالة",
    search: "بحث",
    categories: "الفئات",
    allProducts: "جميع المنتجات",
    bestsellers: "الأكثر مبيعاً",
    newArrivals: "وصل حديثاً",
    description: "الوصف",
    inStock: "متوفر",
    outOfStock: "غير متوفر",
    orderHistory: "سجل الطلبات",
    orderNumber: "رقم الطلب",
    orderDate: "تاريخ الطلب",
    orderStatus: "الحالة",
    downloadPdf: "تحميل PDF",
    editAddress: "تعديل العنوان",
    changePassword: "تغيير كلمة المرور",
    save: "حفظ",
    cancel: "إلغاء",
    status_received: "تم الاستلام",
    status_in_progress: "قيد التجهيز",
    status_shipped: "تم الشحن",
    status_delivered: "تم التسليم",
    companyName: "اسم الشركة",
    contactName: "جهة الاتصال",
    phone: "الهاتف",
    address: "العنوان",
    city: "المدينة",
    postalCode: "الرمز البريدي",
    // New keys for translated pages
    noFavorites: "لا توجد مفضلات",
    goToShop: "اذهب للمتجر",
    errorLoadingFavorites: "خطأ في تحميل المفضلات",
    error: "خطأ",
    noOrders: "لا توجد طلبات",
    paid: "مدفوع",
    pending: "قيد الانتظار",
    downloadInvoice: "تحميل الفاتورة",
    downloadConfirmation: "تحميل التأكيد",
    shippingAddress: "عنوان الشحن",
    paymentMethod: "طريقة الدفع",
    notes: "ملاحظات",
    notesPlaceholder: "مثال: التسليم غداً",
    orderViaWhatsApp: "الطلب عبر واتساب",
    orderSummary: "ملخص الطلب",
    subtotal: "المجموع الفرعي",
    processing: "جاري المعالجة...",
    orderSuccess: "تم الطلب بنجاح",
    orderFailed: "فشل الطلب",
    heroBanner: "منتجات احترافية. طلب سريع. – حصرياً لعملاء B2B في قطاع صالونات الحلاقة.",
    errorLoadingCategories: "خطأ في تحميل الفئات",
    contact: "اتصل بنا",
    imprint: "البصمة",
    privacy: "الخصوصية",
    terms: "الشروط",
    cancellation: "الإلغاء",
    shippingPayment: "الشحن والدفع",
    allRightsReserved: "جميع الحقوق محفوظة.",
    // Login/Register keys
    loginSuccess: "تسجيل الدخول ناجح",
    loginFailed: "فشل تسجيل الدخول. يرجى التحقق من بياناتك.",
    registerSuccess: "تم التسجيل بنجاح",
    registerFailed: "فشل التسجيل. حاول مرة أخرى.",
    createAccount: "إنشاء حساب ED STEEL الخاص بك",
    haveAccount: "هل لديك حساب بالفعل؟",
    productNotFound: "المنتج غير موجود",
    downloadFailed: "فشل التحميل",
    downloadStarted: "بدأ التحميل",
    downloadOrder: "تحميل الطلب",
    // Profile page keys
    b2bOnly: "للعملاء التجاريين فقط (B2B)",
    addressAndContact: "العنوان والاتصال",
    edit: "تعديل",
    saving: "جاري الحفظ...",
    profileUpdated: "تم تحديث الملف الشخصي بنجاح",
    errorSaving: "خطأ في الحفظ",
    passwordSection: "كلمة المرور",
    change: "تغيير",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور الجديدة",
    passwordsNotMatch: "كلمات المرور غير متطابقة",
    passwordTooShort: "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
    passwordChanged: "تم تغيير كلمة المرور بنجاح",
    errorChangingPassword: "خطأ في تغيير كلمة المرور",
    viewOrderHistory: "عرض سجل الطلبات",
    savedProducts: "المنتجات المحفوظة",
    legalSection: "قانوني"
  },
  en: { 
    bkSaveFavorite: "☆ Save as favorite",
    bkSavedFavorite: "Saved as favorite",
    bkAvailableTimes: "Available times",
    loading: "Loading...",
    bkNoSlots: "No free slots available on this day",
    bkNotesOptional: "Notes (optional)",
    bkSubmitting: "Booking...",
    bkSubmitBooking: "Book appointment now",
    bkConfirmationSent: "A confirmation has been sent to {email}.",
    bkOClock: "",
    bkMinutes: "minutes",
    coQuestionsContact: "If you have questions, please contact {name}.",
    toShop: "To shop",
    plSigningIn: "Signing in...",
    toHome: "To homepage",
    psFreeShippingFrom: "Free shipping from €200.00",
    psAddedToCart: "Added to cart!",
    bkToday: "Today",
    bkSelectAll: "Please select service, date and time",
    fillRequired: "Please fill in all required fields",
    fillAll: "Please fill in all fields",
    bkBookedSuccess: "Appointment booked successfully!",
    firstName: "First name",
    lastName: "Last name",
    deliveryAddress: "Delivery address",
    coDeliveryOptional: "Delivery address (optional)",
    zip: "ZIP code",
    country: "Country",
    coCashOnDelivery: "Cash on delivery / pay at pickup",
    coOnlinePayment: "Online payment",
    coOrderNote: "Order note",
    privacyPolicy: "Privacy policy",
    coAcceptTermsError: "Please accept the terms and privacy policy",
    plLoginSuccess: "Login successful!",
    prCreateAccount: "Create account",
    prFasterOrders: "Faster ordering with saved details",
    prPasswordMin8: "Password must be at least 8 characters",
    prRegisterSuccess: "Registration successful!",
    coSuccessInfo: "You will shortly receive a confirmation by email.",
    coNotePlaceholder: "Optional notes...",
    bkStepOf: "Step {step} of {total}",
    bkMin: "min",
    bkService: "Service:",
    bkDuration: "Duration:",
    psAllPricesVat: "All prices incl. VAT.",
    psBookAt: "Book an appointment at {name}",
    psHeroCopy: "Choose your service, your preferred stylist and the right time — conveniently online in just a few clicks.",
    psStepChoose: "Choose\nappointment",
    psStepStylist: "Select\nstylist",
    psStepConfirm: "Get\nconfirmation",
    psAll: "All",
    psSummary: "Summary",
    psUntilFreeShipping: "{amount} to go for free shipping",
    coCheckoutTitle: "Checkout",
    coCardKlarna: "Credit card, Klarna, etc.",
    coIAccept: "I accept the",
    coAnd: "and",
    coProcessing: "Processing...",
    coOrderNow: "Order now",
    psLogin: "Sign in",
    psOnlineAppointment: "Online appointment",
    psBookNow: "Book appointment now",
    psAvailableSlots: "Immediately available slots",
    psBookAgain: "Book again now",
    psNoProducts: "No products available",
    psBackToShop: "Back to shop",
    psAddProducts: "Add products to continue",
    psInclVat: "incl. VAT",
    psBookAppointment: "Book appointment",
    bkChooseService: "Choose your service",
    bkAllOffers: "All offers at a glance — just click",
    bkChooseStaff: "Choose a staff member (optional)",
    bkNoPreference: "No preference",
    bkNextAvailable: "Next available staff member",
    bkChooseDateTime: "Choose date and time",
    date: "Date",
    time: "Time",
    bkYourContact: "Your contact details",
    bkBooked: "Appointment booked!",
    bkDetails: "Appointment details",
    bkBookingNumber: "Booking number:",
    bkAddToCalendar: "Add to calendar",
    bkQuestions: "For questions or changes, please contact the shop directly.",
    bkNotAvailable: "Appointment booking not available",
    bkNotOffered: "This shop currently does not offer online booking.",
    bkBookingTitle: "Appointment booking",
    bkYourSelection: "Your selection",
    bkAcceptTerms: "By booking you accept the shop's terms and conditions.",
    bkAnotherAppointment: "Book another appointment",
    bkNotesPlaceholder: "Special requests or notes...",
    coBackToCart: "Back to cart",
    coContactData: "Contact details",
    coStreet: "Street & house number *",
    coPayOnDelivery: "Pay on delivery or pickup",
    coThankYou: "Thank you for your order!",
    coOrderPlaced: "Your order has been placed successfully.",
    fpIntro: "Enter your email address and we will send you a reset link.",
    fpSending: "Sending...",
    fpSendLink: "Send link",
    fpEmailSent: "Email sent!",
    fpIfAccount: "If an account with",
    fpInfoRest: "exists, you will shortly receive an email with further instructions.",
    fpSpam: "Also check your spam folder if you don't receive an email.",
    backToLogin: "Back to login",
    rpValidating: "Verifying link...",
    rpLinkInvalid: "Invalid link",
    rpRequestNew: "Request new link",
    rpChanged: "Password changed!",
    rpChangedText: "Your password has been reset successfully. You can now sign in.",
    rpToLogin: "Go to login",
    rpEnterNew: "Enter your new password.",
    rpMin8: "At least 8 characters",
    rpRepeat: "Repeat password",
    rpSaving: "Saving...",
    rpSave: "Save password",
    forSms: "(for SMS)",
    registerWithGoogle: "Sign up with Google",
    plWelcomeBack: "Welcome back",
    plRegisterNow: "Register now",
    plYourPassword: "Your password",
    prOrderHistory: "Order history and appointment overview",
    prStreet: "Street and house number",
    status_new: "New",
    print: "Print",
    order: "Order",
    paymentStatus: "Payment status",
    loginWithGoogle: "Sign in with Google",
    or: "or",
    forgotPassword: "Forgot password?",
    productsFound: "{count} products found",
    details: "Details",
    free: "Free",
    pageOf: "Page {page} of {total}",
    tryOtherSearch: "Try a different search.",
    productWorlds: "Panasonic Product Worlds",
    chooseWorld: "Choose your product world to discover the right range",
    whyPanasonic: "Why Panasonic?",
    qualityTitle: "Japanese Quality",
    qualityText: "Highest manufacturing standards and durability for professional use",
    toolsTitle: "Professional Tools",
    toolsText: "Specially developed for the needs of hairdressers and barbershops",
    techTitle: "Innovative Technology",
    techText: "Latest technologies for efficient work and best results",
    discoverProducts: "Discover products",
    noShopYet: "You haven't set up a customer shop yet",
    noShopYetText: "Create your white-label shop to sell Panasonic products to your own customers and offer online appointments.",
    setupShopNow: "Set up shop now →",
    chooseArea: "Choose the product area you want.",
    openArea: "Open product area",
    originalWarranty: "All Panasonic products are original branded goods with manufacturer's warranty.",
    backToWorlds: "Back to Panasonic Product Worlds",
    backTo: "Back to {name}",
    subcategories: "Subcategories",
    viewProducts: "View products",
    productsInCategory: "Products in this category",
    clickToViewProducts: "Click here to view all products in \"{name}\".",
    showProducts: "Show products",
    noCategories: "No categories available.",
    searchProduct: "Search product...",
    back: "Back",
    next: "Next",
    allCategories: "All categories",
    searchProducts: "Search products...",
    showMoreProducts: "Show more products",
    shownOfProducts: "{shown} of {total} products shown",
    orderedItems: "Ordered items",
    orderNotFound: "Order not found",
    b2bTagline: "B2B wholesale for barbershops and hair salons",
    customerService: "Customer service",
    noNewNotifications: "No new notifications",
    viewPublicShop: "View public shop",
    manageShop: "Manage my customer shop",
    noProductsInCategory: "There are no products available in this category yet.",
    home: "Home", 
    shop: "Shop", 
    cart: "Cart", 
    favorites: "Favorites", 
    profile: "Profile",
    orders: "Orders",
    admin: "Admin",
    logout: "Logout",
    login: "Login",
    register: "Register",
    products: "Products",
    addToCart: "Add to Cart",
    loading: "Loading...",
    noProducts: "No products found",
    addedToFavorites: "Added to favorites",
    removedFromFavorites: "Removed from favorites",
    addedToCart: "Product added to cart",
    errorLoadingProducts: "Error loading products",
    errorUpdatingFavorites: "Error updating favorites",
    welcomeBack: "Welcome back to ED STEEL",
    email: "Email",
    password: "Password",
    noAccount: "Don't have an account?",
    checkout: "Checkout",
    total: "Total",
    shipping: "Shipping",
    freeShipping: "Free Shipping",
    freeShippingFrom: "Free shipping on orders over €200",
    remainingForFreeShipping: "{amount} remaining for free shipping",
    emptyCart: "Your cart is empty",
    continueShopping: "Continue shopping",
    orderConfirmation: "Order Confirmation",
    orderPlaced: "Your order has been placed",
    payOnDelivery: "Cash on Delivery",
    onlinePayment: "Pay Online",
    placeOrder: "Place Order",
    quantity: "Quantity",
    price: "Price",
    priceNet: "Net",
    priceGross: "Gross",
    artNr: "SKU",
    remove: "Remove",
    search: "Search",
    categories: "Categories",
    allProducts: "All Products",
    bestsellers: "Bestsellers",
    newArrivals: "New Arrivals",
    description: "Description",
    inStock: "In Stock",
    outOfStock: "Out of Stock",
    orderHistory: "Order History",
    orderNumber: "Order Number",
    orderDate: "Order Date",
    orderStatus: "Status",
    downloadPdf: "Download PDF",
    editAddress: "Edit Address",
    changePassword: "Change Password",
    save: "Save",
    cancel: "Cancel",
    status_received: "Received",
    status_in_progress: "In Progress",
    status_shipped: "Shipped",
    status_delivered: "Delivered",
    companyName: "Company Name",
    contactName: "Contact Name",
    phone: "Phone",
    address: "Address",
    city: "City",
    postalCode: "Postal Code",
    // New keys for translated pages
    noFavorites: "No favorites yet",
    goToShop: "Go to Shop",
    errorLoadingFavorites: "Error loading favorites",
    error: "Error",
    noOrders: "No orders yet",
    paid: "Paid",
    pending: "Pending",
    downloadInvoice: "Download Invoice",
    downloadConfirmation: "Download Confirmation",
    shippingAddress: "Shipping Address",
    paymentMethod: "Payment Method",
    notes: "Notes",
    notesPlaceholder: "e.g. Please deliver tomorrow",
    orderViaWhatsApp: "Order via WhatsApp",
    orderSummary: "Order Summary",
    subtotal: "Subtotal",
    processing: "Processing...",
    orderSuccess: "Order placed successfully",
    orderFailed: "Order failed",
    heroBanner: "PROFESSIONAL PRODUCTS. FAST ORDERING. – Exclusively for B2B customers in the barbershop industry.",
    errorLoadingCategories: "Error loading categories",
    contact: "Contact",
    imprint: "Imprint",
    privacy: "Privacy",
    terms: "Terms",
    cancellation: "Cancellation",
    shippingPayment: "Shipping & Payment",
    allRightsReserved: "All rights reserved.",
    // Login/Register keys
    loginSuccess: "Login successful",
    loginFailed: "Login failed. Please check your credentials.",
    registerSuccess: "Registration successful",
    registerFailed: "Registration failed. Please try again.",
    createAccount: "Create your ED STEEL account",
    haveAccount: "Already have an account?",
    productNotFound: "Product not found",
    downloadFailed: "Download failed",
    downloadStarted: "Download started",
    downloadOrder: "Download order",
    // Profile page keys
    b2bOnly: "For B2B customers only",
    addressAndContact: "Address & Contact",
    edit: "Edit",
    saving: "Saving...",
    profileUpdated: "Profile updated successfully",
    errorSaving: "Error saving",
    passwordSection: "Password",
    change: "Change",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
    passwordsNotMatch: "Passwords do not match",
    passwordTooShort: "Password must be at least 6 characters",
    passwordChanged: "Password changed successfully",
    errorChangingPassword: "Error changing password",
    viewOrderHistory: "View order history",
    savedProducts: "Saved products",
    legalSection: "Legal"
  },
  it: { 
    bkSaveFavorite: "☆ Salva come preferito",
    bkSavedFavorite: "Salvato come preferito",
    bkAvailableTimes: "Orari disponibili",
    loading: "Caricamento...",
    bkNoSlots: "Nessun appuntamento disponibile in questo giorno",
    bkNotesOptional: "Note (opzionale)",
    bkSubmitting: "Prenotazione...",
    bkSubmitBooking: "Prenota definitivamente",
    bkConfirmationSent: "Una conferma è stata inviata a {email}.",
    bkOClock: "",
    bkMinutes: "minuti",
    coQuestionsContact: "Per domande, contatta {name}.",
    toShop: "Al negozio",
    plSigningIn: "Accesso in corso...",
    toHome: "Alla home page",
    psFreeShippingFrom: "Spedizione gratuita da 200,00 €",
    psAddedToCart: "Aggiunto al carrello!",
    bkToday: "Oggi",
    bkSelectAll: "Seleziona servizio, data e ora",
    fillRequired: "Compila tutti i campi obbligatori",
    fillAll: "Compila tutti i campi",
    bkBookedSuccess: "Appuntamento prenotato con successo!",
    firstName: "Nome",
    lastName: "Cognome",
    deliveryAddress: "Indirizzo di consegna",
    coDeliveryOptional: "Indirizzo di consegna (opzionale)",
    zip: "CAP",
    country: "Paese",
    coCashOnDelivery: "Contrassegno / pagamento al ritiro",
    coOnlinePayment: "Pagamento online",
    coOrderNote: "Nota sull'ordine",
    privacyPolicy: "Informativa sulla privacy",
    coAcceptTermsError: "Accetta i termini e l'informativa sulla privacy",
    plLoginSuccess: "Accesso riuscito!",
    prCreateAccount: "Crea account",
    prFasterOrders: "Ordini più rapidi con i dati salvati",
    prPasswordMin8: "La password deve avere almeno 8 caratteri",
    prRegisterSuccess: "Registrazione riuscita!",
    coSuccessInfo: "Riceverai a breve una conferma via email.",
    coNotePlaceholder: "Note opzionali...",
    bkStepOf: "Passo {step} di {total}",
    bkMin: "min",
    bkService: "Servizio:",
    bkDuration: "Durata:",
    psAllPricesVat: "Tutti i prezzi IVA inclusa.",
    psBookAt: "Prenota un appuntamento da {name}",
    psHeroCopy: "Scegli il servizio, lo stilista preferito e l'orario giusto — comodamente online in pochi clic.",
    psStepChoose: "Scegli\nappuntamento",
    psStepStylist: "Scegli\nstilista",
    psStepConfirm: "Ricevi\nconferma",
    psAll: "Tutti",
    psSummary: "Riepilogo",
    psUntilFreeShipping: "Mancano {amount} alla spedizione gratuita",
    coCheckoutTitle: "Cassa",
    coCardKlarna: "Carta di credito, Klarna, ecc.",
    coIAccept: "Accetto",
    coAnd: "e",
    coProcessing: "Elaborazione...",
    coOrderNow: "Ordina ora",
    psLogin: "Accedi",
    psOnlineAppointment: "Appuntamento online",
    psBookNow: "Prenota ora un appuntamento",
    psAvailableSlots: "Slot subito disponibili",
    psBookAgain: "Prenota di nuovo",
    psNoProducts: "Nessun prodotto disponibile",
    psBackToShop: "Torna al negozio",
    psAddProducts: "Aggiungi prodotti per continuare",
    psInclVat: "IVA incl.",
    psBookAppointment: "Prenota appuntamento",
    bkChooseService: "Scegli il tuo servizio",
    bkAllOffers: "Tutte le offerte a colpo d'occhio — basta cliccare",
    bkChooseStaff: "Scegli un collaboratore (opzionale)",
    bkNoPreference: "Nessuna preferenza",
    bkNextAvailable: "Prossimo collaboratore disponibile",
    bkChooseDateTime: "Scegli data e ora",
    date: "Data",
    time: "Ora",
    bkYourContact: "I tuoi dati di contatto",
    bkBooked: "Appuntamento prenotato!",
    bkDetails: "Dettagli appuntamento",
    bkBookingNumber: "Numero di prenotazione:",
    bkAddToCalendar: "Aggiungi al calendario",
    bkQuestions: "Per domande o modifiche, contatta direttamente il negozio.",
    bkNotAvailable: "Prenotazione non disponibile",
    bkNotOffered: "Questo negozio al momento non offre prenotazioni online.",
    bkBookingTitle: "Prenotazione appuntamento",
    bkYourSelection: "La tua selezione",
    bkAcceptTerms: "Con la prenotazione accetti i termini del negozio.",
    bkAnotherAppointment: "Prenota un altro appuntamento",
    bkNotesPlaceholder: "Richieste particolari o note...",
    coBackToCart: "Torna al carrello",
    coContactData: "Dati di contatto",
    coStreet: "Via e numero civico *",
    coPayOnDelivery: "Paga alla consegna o al ritiro",
    coThankYou: "Grazie per il tuo ordine!",
    coOrderPlaced: "Il tuo ordine è stato effettuato con successo.",
    fpIntro: "Inserisci la tua email e ti invieremo un link di ripristino.",
    fpSending: "Invio in corso...",
    fpSendLink: "Invia link",
    fpEmailSent: "Email inviata!",
    fpIfAccount: "Se esiste un account con",
    fpInfoRest: "riceverai a breve un'email con ulteriori istruzioni.",
    fpSpam: "Controlla anche la cartella spam se non ricevi l'email.",
    backToLogin: "Torna al login",
    rpValidating: "Verifica del link...",
    rpLinkInvalid: "Link non valido",
    rpRequestNew: "Richiedi nuovo link",
    rpChanged: "Password modificata!",
    rpChangedText: "La tua password è stata reimpostata. Ora puoi accedere.",
    rpToLogin: "Vai al login",
    rpEnterNew: "Inserisci la nuova password.",
    rpMin8: "Almeno 8 caratteri",
    rpRepeat: "Ripeti la password",
    rpSaving: "Salvataggio...",
    rpSave: "Salva password",
    forSms: "(per SMS)",
    registerWithGoogle: "Registrati con Google",
    plWelcomeBack: "Bentornato",
    plRegisterNow: "Registrati ora",
    plYourPassword: "La tua password",
    prOrderHistory: "Cronologia ordini e panoramica appuntamenti",
    prStreet: "Via e numero civico",
    status_new: "Nuovo",
    print: "Stampa",
    order: "Ordine",
    paymentStatus: "Stato del pagamento",
    loginWithGoogle: "Accedi con Google",
    or: "oppure",
    forgotPassword: "Password dimenticata?",
    productsFound: "{count} prodotti trovati",
    details: "Dettagli",
    free: "Gratis",
    pageOf: "Pagina {page} di {total}",
    tryOtherSearch: "Prova un'altra ricerca.",
    productWorlds: "Mondi di prodotti Panasonic",
    chooseWorld: "Scegli il tuo mondo di prodotti per scoprire l'assortimento giusto",
    whyPanasonic: "Perché Panasonic?",
    qualityTitle: "Qualità giapponese",
    qualityText: "Massimi standard di produzione e durabilità per l'uso professionale",
    toolsTitle: "Strumenti professionali",
    toolsText: "Sviluppati appositamente per le esigenze di parrucchieri e barbershop",
    techTitle: "Tecnologia innovativa",
    techText: "Le tecnologie più recenti per un lavoro efficiente e i migliori risultati",
    discoverProducts: "Scopri i prodotti",
    noShopYet: "Non hai ancora configurato un negozio per i clienti",
    noShopYetText: "Crea il tuo negozio white-label per vendere prodotti Panasonic ai tuoi clienti e offrire appuntamenti online.",
    setupShopNow: "Configura il negozio ora →",
    chooseArea: "Scegli l'area prodotti desiderata.",
    openArea: "Apri l'area prodotti",
    originalWarranty: "Tutti i prodotti Panasonic sono originali con garanzia del produttore.",
    backToWorlds: "Torna ai mondi di prodotti Panasonic",
    backTo: "Torna a {name}",
    subcategories: "Sottocategorie",
    viewProducts: "Vedi prodotti",
    productsInCategory: "Prodotti in questa categoria",
    clickToViewProducts: "Clicca qui per vedere tutti i prodotti in \"{name}\".",
    showProducts: "Mostra prodotti",
    noCategories: "Nessuna categoria disponibile.",
    searchProduct: "Cerca prodotto...",
    back: "Indietro",
    next: "Avanti",
    allCategories: "Tutte le categorie",
    searchProducts: "Cerca prodotti...",
    showMoreProducts: "Mostra altri prodotti",
    shownOfProducts: "{shown} di {total} prodotti visualizzati",
    orderedItems: "Articoli ordinati",
    orderNotFound: "Ordine non trovato",
    b2bTagline: "Vendita all'ingrosso B2B per barbershop e saloni",
    customerService: "Servizio clienti",
    noNewNotifications: "Nessuna nuova notifica",
    viewPublicShop: "Vedi negozio pubblico",
    manageShop: "Gestisci il mio negozio clienti",
    noProductsInCategory: "Non ci sono ancora prodotti disponibili in questa categoria.",
    home: "Home", 
    shop: "Negozio", 
    cart: "Carrello", 
    favorites: "Preferiti", 
    profile: "Profilo",
    orders: "Ordini",
    admin: "Admin",
    logout: "Esci",
    login: "Accedi",
    register: "Registrati",
    products: "Prodotti",
    addToCart: "Aggiungi al carrello",
    loading: "Caricamento...",
    noProducts: "Nessun prodotto trovato",
    addedToFavorites: "Aggiunto ai preferiti",
    removedFromFavorites: "Rimosso dai preferiti",
    addedToCart: "Prodotto aggiunto al carrello",
    errorLoadingProducts: "Errore nel caricamento prodotti",
    errorUpdatingFavorites: "Errore nell'aggiornamento preferiti",
    welcomeBack: "Bentornato su ED STEEL",
    email: "Email",
    password: "Password",
    noAccount: "Non hai un account?",
    checkout: "Vai al pagamento",
    total: "Totale",
    shipping: "Spedizione",
    freeShipping: "Spedizione gratuita",
    freeShippingFrom: "Spedizione gratuita sopra €200",
    remainingForFreeShipping: "Mancano {amount} per la spedizione gratuita",
    emptyCart: "Il carrello è vuoto",
    continueShopping: "Continua lo shopping",
    orderConfirmation: "Conferma ordine",
    orderPlaced: "Ordine effettuato",
    payOnDelivery: "Pagamento alla consegna",
    onlinePayment: "Paga online",
    placeOrder: "Conferma ordine",
    quantity: "Quantità",
    price: "Prezzo",
    priceNet: "Netto",
    priceGross: "Lordo",
    artNr: "Art.",
    remove: "Rimuovi",
    search: "Cerca",
    categories: "Categorie",
    allProducts: "Tutti i prodotti",
    bestsellers: "Più venduti",
    newArrivals: "Novità",
    description: "Descrizione",
    inStock: "Disponibile",
    outOfStock: "Non disponibile",
    orderHistory: "Storico ordini",
    orderNumber: "Numero ordine",
    orderDate: "Data ordine",
    orderStatus: "Stato",
    downloadPdf: "Scarica PDF",
    editAddress: "Modifica indirizzo",
    changePassword: "Cambia password",
    save: "Salva",
    cancel: "Annulla",
    status_received: "Ricevuto",
    status_in_progress: "In lavorazione",
    status_shipped: "Spedito",
    status_delivered: "Consegnato",
    companyName: "Nome azienda",
    contactName: "Nome contatto",
    phone: "Telefono",
    address: "Indirizzo",
    city: "Città",
    postalCode: "CAP",
    // New keys for translated pages
    noFavorites: "Nessun preferito",
    goToShop: "Vai al negozio",
    errorLoadingFavorites: "Errore nel caricamento preferiti",
    error: "Errore",
    noOrders: "Nessun ordine",
    paid: "Pagato",
    pending: "In attesa",
    downloadInvoice: "Scarica Fattura",
    downloadConfirmation: "Scarica Conferma",
    shippingAddress: "Indirizzo di spedizione",
    paymentMethod: "Metodo di pagamento",
    notes: "Note",
    notesPlaceholder: "Es: Consegna domani",
    orderViaWhatsApp: "Ordina via WhatsApp",
    orderSummary: "Riepilogo ordine",
    subtotal: "Subtotale",
    processing: "Elaborazione...",
    orderSuccess: "Ordine effettuato con successo",
    orderFailed: "Ordine fallito",
    heroBanner: "PRODOTTI PROFESSIONALI. ORDINI RAPIDI. – Esclusivo per clienti B2B nel settore barbiere.",
    errorLoadingCategories: "Errore nel caricamento categorie",
    contact: "Contatto",
    imprint: "Impronta",
    privacy: "Privacy",
    terms: "Termini",
    cancellation: "Cancellazione",
    shippingPayment: "Spedizione & Pagamento",
    allRightsReserved: "Tutti i diritti riservati.",
    // Login/Register keys
    loginSuccess: "Accesso riuscito",
    loginFailed: "Accesso fallito. Controlla le credenziali.",
    registerSuccess: "Registrazione riuscita",
    registerFailed: "Registrazione fallita. Riprova.",
    createAccount: "Crea il tuo account ED STEEL",
    haveAccount: "Hai già un account?",
    productNotFound: "Prodotto non trovato",
    downloadFailed: "Download fallito",
    downloadStarted: "Download avviato",
    downloadOrder: "Scarica ordine",
    // Profile page keys
    b2bOnly: "Solo per clienti B2B",
    addressAndContact: "Indirizzo & Contatto",
    edit: "Modifica",
    saving: "Salvataggio...",
    profileUpdated: "Profilo aggiornato con successo",
    errorSaving: "Errore nel salvataggio",
    passwordSection: "Password",
    change: "Cambia",
    currentPassword: "Password Attuale",
    newPassword: "Nuova Password",
    confirmPassword: "Conferma Nuova Password",
    passwordsNotMatch: "Le password non corrispondono",
    passwordTooShort: "La password deve essere di almeno 6 caratteri",
    passwordChanged: "Password cambiata con successo",
    errorChangingPassword: "Errore nel cambio password",
    viewOrderHistory: "Visualizza storico ordini",
    savedProducts: "Prodotti salvati",
    legalSection: "Legale"
  },
  fr: { 
    bkSaveFavorite: "☆ Enregistrer comme favori",
    bkSavedFavorite: "Enregistré comme favori",
    bkAvailableTimes: "Horaires disponibles",
    loading: "Chargement...",
    bkNoSlots: "Aucun créneau disponible ce jour-là",
    bkNotesOptional: "Remarques (facultatif)",
    bkSubmitting: "Réservation...",
    bkSubmitBooking: "Réserver définitivement",
    bkConfirmationSent: "Une confirmation a été envoyée à {email}.",
    bkOClock: "",
    bkMinutes: "minutes",
    coQuestionsContact: "Pour toute question, veuillez contacter {name}.",
    toShop: "Vers la boutique",
    plSigningIn: "Connexion...",
    toHome: "Vers l'accueil",
    psFreeShippingFrom: "Livraison gratuite dès 200,00 €",
    psAddedToCart: "Ajouté au panier !",
    bkToday: "Aujourd'hui",
    bkSelectAll: "Veuillez choisir la prestation, la date et l'heure",
    fillRequired: "Veuillez remplir tous les champs obligatoires",
    fillAll: "Veuillez remplir tous les champs",
    bkBookedSuccess: "Rendez-vous réservé avec succès !",
    firstName: "Prénom",
    lastName: "Nom",
    deliveryAddress: "Adresse de livraison",
    coDeliveryOptional: "Adresse de livraison (facultatif)",
    zip: "Code postal",
    country: "Pays",
    coCashOnDelivery: "Paiement à la livraison / au retrait",
    coOnlinePayment: "Paiement en ligne",
    coOrderNote: "Remarque sur la commande",
    privacyPolicy: "Politique de confidentialité",
    coAcceptTermsError: "Veuillez accepter les CGV et la politique de confidentialité",
    plLoginSuccess: "Connexion réussie !",
    prCreateAccount: "Créer un compte",
    prFasterOrders: "Commande plus rapide avec vos données enregistrées",
    prPasswordMin8: "Le mot de passe doit contenir au moins 8 caractères",
    prRegisterSuccess: "Inscription réussie !",
    coSuccessInfo: "Vous recevrez sous peu une confirmation par e-mail.",
    coNotePlaceholder: "Remarques facultatives...",
    bkStepOf: "Étape {step} sur {total}",
    bkMin: "min",
    bkService: "Prestation :",
    bkDuration: "Durée :",
    psAllPricesVat: "Tous les prix TTC.",
    psBookAt: "Prendre rendez-vous chez {name}",
    psHeroCopy: "Choisissez votre prestation, votre styliste préféré et le bon moment — en ligne en quelques clics.",
    psStepChoose: "Choisir\nle rendez-vous",
    psStepStylist: "Choisir\nle styliste",
    psStepConfirm: "Recevoir\nla confirmation",
    psAll: "Tous",
    psSummary: "Récapitulatif",
    psUntilFreeShipping: "Encore {amount} pour la livraison gratuite",
    coCheckoutTitle: "Caisse",
    coCardKlarna: "Carte de crédit, Klarna, etc.",
    coIAccept: "J'accepte les",
    coAnd: "et",
    coProcessing: "Traitement...",
    coOrderNow: "Commander maintenant",
    psLogin: "Se connecter",
    psOnlineAppointment: "Rendez-vous en ligne",
    psBookNow: "Réserver un rendez-vous",
    psAvailableSlots: "Créneaux disponibles immédiatement",
    psBookAgain: "Réserver à nouveau",
    psNoProducts: "Aucun produit disponible",
    psBackToShop: "Retour à la boutique",
    psAddProducts: "Ajoutez des produits pour continuer",
    psInclVat: "TVA incluse",
    psBookAppointment: "Prendre rendez-vous",
    bkChooseService: "Choisissez votre prestation",
    bkAllOffers: "Toutes les offres en un coup d'œil — cliquez simplement",
    bkChooseStaff: "Choisissez un collaborateur (facultatif)",
    bkNoPreference: "Aucune préférence",
    bkNextAvailable: "Prochain collaborateur disponible",
    bkChooseDateTime: "Choisissez la date et l'heure",
    date: "Date",
    time: "Heure",
    bkYourContact: "Vos coordonnées",
    bkBooked: "Rendez-vous réservé !",
    bkDetails: "Détails du rendez-vous",
    bkBookingNumber: "Numéro de réservation :",
    bkAddToCalendar: "Ajouter au calendrier",
    bkQuestions: "Pour toute question ou modification, contactez directement la boutique.",
    bkNotAvailable: "Réservation non disponible",
    bkNotOffered: "Cette boutique ne propose pas de réservation en ligne pour le moment.",
    bkBookingTitle: "Réservation",
    bkYourSelection: "Votre sélection",
    bkAcceptTerms: "En réservant, vous acceptez les CGV de la boutique.",
    bkAnotherAppointment: "Réserver un autre rendez-vous",
    bkNotesPlaceholder: "Demandes particulières ou remarques...",
    coBackToCart: "Retour au panier",
    coContactData: "Coordonnées",
    coStreet: "Rue et numéro *",
    coPayOnDelivery: "Payez à la livraison ou au retrait",
    coThankYou: "Merci pour votre commande !",
    coOrderPlaced: "Votre commande a été passée avec succès.",
    fpIntro: "Saisissez votre e-mail et nous vous enverrons un lien de réinitialisation.",
    fpSending: "Envoi en cours...",
    fpSendLink: "Envoyer le lien",
    fpEmailSent: "E-mail envoyé !",
    fpIfAccount: "Si un compte avec",
    fpInfoRest: "existe, vous recevrez sous peu un e-mail avec des instructions.",
    fpSpam: "Vérifiez aussi votre dossier spam si vous ne recevez rien.",
    backToLogin: "Retour à la connexion",
    rpValidating: "Vérification du lien...",
    rpLinkInvalid: "Lien invalide",
    rpRequestNew: "Demander un nouveau lien",
    rpChanged: "Mot de passe modifié !",
    rpChangedText: "Votre mot de passe a été réinitialisé. Vous pouvez vous connecter.",
    rpToLogin: "Aller à la connexion",
    rpEnterNew: "Saisissez votre nouveau mot de passe.",
    rpMin8: "Au moins 8 caractères",
    rpRepeat: "Répétez le mot de passe",
    rpSaving: "Enregistrement...",
    rpSave: "Enregistrer le mot de passe",
    forSms: "(pour SMS)",
    registerWithGoogle: "S'inscrire avec Google",
    plWelcomeBack: "Bon retour",
    plRegisterNow: "S'inscrire maintenant",
    plYourPassword: "Votre mot de passe",
    prOrderHistory: "Historique des commandes et aperçu des rendez-vous",
    prStreet: "Rue et numéro",
    status_new: "Nouveau",
    print: "Imprimer",
    order: "Commande",
    paymentStatus: "Statut du paiement",
    loginWithGoogle: "Se connecter avec Google",
    or: "ou",
    forgotPassword: "Mot de passe oublié ?",
    productsFound: "{count} produits trouvés",
    details: "Détails",
    free: "Gratuit",
    pageOf: "Page {page} sur {total}",
    tryOtherSearch: "Essayez une autre recherche.",
    productWorlds: "Univers de produits Panasonic",
    chooseWorld: "Choisissez votre univers de produits pour découvrir la gamme adaptée",
    whyPanasonic: "Pourquoi Panasonic ?",
    qualityTitle: "Qualité japonaise",
    qualityText: "Normes de fabrication les plus élevées et durabilité pour un usage professionnel",
    toolsTitle: "Outils professionnels",
    toolsText: "Spécialement conçus pour les besoins des coiffeurs et des barbershops",
    techTitle: "Technologie innovante",
    techText: "Les technologies les plus récentes pour un travail efficace et les meilleurs résultats",
    discoverProducts: "Découvrir les produits",
    noShopYet: "Vous n'avez pas encore configuré de boutique client",
    noShopYetText: "Créez votre boutique en marque blanche pour vendre des produits Panasonic à vos clients et proposer des rendez-vous en ligne.",
    setupShopNow: "Créer la boutique maintenant →",
    chooseArea: "Choisissez le domaine de produits souhaité.",
    openArea: "Ouvrir le domaine de produits",
    originalWarranty: "Tous les produits Panasonic sont des articles de marque originaux avec garantie du fabricant.",
    backToWorlds: "Retour aux univers de produits Panasonic",
    backTo: "Retour à {name}",
    subcategories: "Sous-catégories",
    viewProducts: "Voir les produits",
    productsInCategory: "Produits dans cette catégorie",
    clickToViewProducts: "Cliquez ici pour voir tous les produits dans \"{name}\".",
    showProducts: "Afficher les produits",
    noCategories: "Aucune catégorie disponible.",
    searchProduct: "Rechercher un produit...",
    back: "Retour",
    next: "Suivant",
    allCategories: "Toutes les catégories",
    searchProducts: "Rechercher des produits...",
    showMoreProducts: "Afficher plus de produits",
    shownOfProducts: "{shown} sur {total} produits affichés",
    orderedItems: "Articles commandés",
    orderNotFound: "Commande introuvable",
    b2bTagline: "Vente en gros B2B pour barbershops et salons de coiffure",
    customerService: "Service client",
    noNewNotifications: "Aucune nouvelle notification",
    viewPublicShop: "Voir la boutique publique",
    manageShop: "Gérer ma boutique client",
    noProductsInCategory: "Aucun produit disponible dans cette catégorie pour le moment.",
    home: "Accueil", 
    shop: "Boutique", 
    cart: "Panier", 
    favorites: "Favoris", 
    profile: "Profil",
    orders: "Commandes",
    admin: "Admin",
    logout: "Déconnexion",
    login: "Connexion",
    register: "S'inscrire",
    products: "Produits",
    addToCart: "Ajouter au panier",
    loading: "Chargement...",
    noProducts: "Aucun produit trouvé",
    addedToFavorites: "Ajouté aux favoris",
    removedFromFavorites: "Retiré des favoris",
    addedToCart: "Produit ajouté au panier",
    errorLoadingProducts: "Erreur de chargement des produits",
    errorUpdatingFavorites: "Erreur de mise à jour des favoris",
    welcomeBack: "Bienvenue sur ED STEEL",
    email: "Email",
    password: "Mot de passe",
    noAccount: "Pas de compte?",
    checkout: "Commander",
    total: "Total",
    shipping: "Livraison",
    freeShipping: "Livraison gratuite",
    freeShippingFrom: "Livraison gratuite dès 200€",
    remainingForFreeShipping: "Plus que {amount} pour la livraison gratuite",
    emptyCart: "Votre panier est vide",
    continueShopping: "Continuer vos achats",
    orderConfirmation: "Confirmation de commande",
    orderPlaced: "Commande passée",
    payOnDelivery: "Paiement à la livraison",
    onlinePayment: "Payer en ligne",
    placeOrder: "Passer la commande",
    quantity: "Quantité",
    price: "Prix",
    priceNet: "Net",
    priceGross: "Brut",
    artNr: "Réf.",
    remove: "Supprimer",
    search: "Rechercher",
    categories: "Catégories",
    allProducts: "Tous les produits",
    bestsellers: "Meilleures ventes",
    newArrivals: "Nouveautés",
    description: "Description",
    inStock: "En stock",
    outOfStock: "Rupture de stock",
    orderHistory: "Historique commandes",
    orderNumber: "N° de commande",
    orderDate: "Date de commande",
    orderStatus: "Statut",
    downloadPdf: "Télécharger PDF",
    editAddress: "Modifier l'adresse",
    changePassword: "Changer mot de passe",
    save: "Enregistrer",
    cancel: "Annuler",
    status_received: "Reçue",
    status_in_progress: "En cours",
    status_shipped: "Expédiée",
    status_delivered: "Livrée",
    companyName: "Nom de l'entreprise",
    contactName: "Nom du contact",
    phone: "Téléphone",
    address: "Adresse",
    city: "Ville",
    postalCode: "Code postal",
    // New keys for translated pages
    noFavorites: "Pas de favoris",
    goToShop: "Aller à la boutique",
    errorLoadingFavorites: "Erreur de chargement des favoris",
    error: "Erreur",
    noOrders: "Pas de commandes",
    paid: "Payé",
    pending: "En attente",
    downloadInvoice: "Télécharger la facture",
    downloadConfirmation: "Télécharger la confirmation",
    shippingAddress: "Adresse de livraison",
    paymentMethod: "Mode de paiement",
    notes: "Notes",
    notesPlaceholder: "Ex: Livraison demain",
    orderViaWhatsApp: "Commander via WhatsApp",
    orderSummary: "Récapitulatif",
    subtotal: "Sous-total",
    processing: "Traitement...",
    orderSuccess: "Commande passée avec succès",
    orderFailed: "Commande échouée",
    heroBanner: "PRODUITS PRO. COMMANDE RAPIDE. – Exclusif pour les clients B2B du secteur barbier.",
    errorLoadingCategories: "Erreur de chargement des catégories",
    contact: "Contact",
    imprint: "Mentions légales",
    privacy: "Confidentialité",
    terms: "CGV",
    cancellation: "Rétractation",
    shippingPayment: "Livraison & Paiement",
    allRightsReserved: "Tous droits réservés.",
    // Login/Register keys
    loginSuccess: "Connexion réussie",
    loginFailed: "Connexion échouée. Vérifiez vos identifiants.",
    registerSuccess: "Inscription réussie",
    registerFailed: "Inscription échouée. Veuillez réessayer.",
    createAccount: "Créez votre compte ED STEEL",
    haveAccount: "Vous avez déjà un compte?",
    productNotFound: "Produit non trouvé",
    downloadFailed: "Échec du téléchargement",
    downloadStarted: "Téléchargement démarré",
    downloadOrder: "Télécharger commande",
    // Profile page keys
    b2bOnly: "Réservé aux clients B2B",
    addressAndContact: "Adresse & Contact",
    edit: "Modifier",
    saving: "Enregistrement...",
    profileUpdated: "Profil mis à jour avec succès",
    errorSaving: "Erreur lors de l'enregistrement",
    passwordSection: "Mot de passe",
    change: "Changer",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le nouveau mot de passe",
    passwordsNotMatch: "Les mots de passe ne correspondent pas",
    passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
    passwordChanged: "Mot de passe changé avec succès",
    errorChangingPassword: "Erreur lors du changement de mot de passe",
    viewOrderHistory: "Voir l'historique des commandes",
    savedProducts: "Produits enregistrés",
    legalSection: "Juridique"
  },
  es: { 
    bkSaveFavorite: "☆ Guardar como favorito",
    bkSavedFavorite: "Guardado como favorito",
    bkAvailableTimes: "Horarios disponibles",
    loading: "Cargando...",
    bkNoSlots: "No hay citas disponibles este día",
    bkNotesOptional: "Notas (opcional)",
    bkSubmitting: "Reservando...",
    bkSubmitBooking: "Reservar la cita",
    bkConfirmationSent: "Se ha enviado una confirmación a {email}.",
    bkOClock: "",
    bkMinutes: "minutos",
    coQuestionsContact: "Si tiene preguntas, contacte con {name}.",
    toShop: "A la tienda",
    plSigningIn: "Iniciando sesión...",
    toHome: "A la página principal",
    psFreeShippingFrom: "Envío gratis a partir de 200,00 €",
    psAddedToCart: "¡Añadido al carrito!",
    bkToday: "Hoy",
    bkSelectAll: "Seleccione servicio, fecha y hora",
    fillRequired: "Complete todos los campos obligatorios",
    fillAll: "Complete todos los campos",
    bkBookedSuccess: "¡Cita reservada con éxito!",
    firstName: "Nombre",
    lastName: "Apellido",
    deliveryAddress: "Dirección de entrega",
    coDeliveryOptional: "Dirección de entrega (opcional)",
    zip: "Código postal",
    country: "País",
    coCashOnDelivery: "Contra reembolso / pago al recoger",
    coOnlinePayment: "Pago online",
    coOrderNote: "Nota del pedido",
    privacyPolicy: "Política de privacidad",
    coAcceptTermsError: "Acepte los términos y la política de privacidad",
    plLoginSuccess: "¡Inicio de sesión correcto!",
    prCreateAccount: "Crear cuenta",
    prFasterOrders: "Pedidos más rápidos con datos guardados",
    prPasswordMin8: "La contraseña debe tener al menos 8 caracteres",
    prRegisterSuccess: "¡Registro correcto!",
    coSuccessInfo: "Recibirá en breve una confirmación por correo.",
    coNotePlaceholder: "Notas opcionales...",
    bkStepOf: "Paso {step} de {total}",
    bkMin: "min",
    bkService: "Servicio:",
    bkDuration: "Duración:",
    psAllPricesVat: "Todos los precios con IVA incluido.",
    psBookAt: "Reservar cita en {name}",
    psHeroCopy: "Elija su servicio, su estilista preferido y el momento adecuado — cómodamente online en pocos clics.",
    psStepChoose: "Elegir\ncita",
    psStepStylist: "Elegir\nestilista",
    psStepConfirm: "Recibir\nconfirmación",
    psAll: "Todos",
    psSummary: "Resumen",
    psUntilFreeShipping: "Faltan {amount} para el envío gratis",
    coCheckoutTitle: "Caja",
    coCardKlarna: "Tarjeta de crédito, Klarna, etc.",
    coIAccept: "Acepto los",
    coAnd: "y",
    coProcessing: "Procesando...",
    coOrderNow: "Pedir ahora",
    psLogin: "Iniciar sesión",
    psOnlineAppointment: "Cita online",
    psBookNow: "Reservar cita ahora",
    psAvailableSlots: "Horarios disponibles ahora",
    psBookAgain: "Reservar de nuevo",
    psNoProducts: "No hay productos disponibles",
    psBackToShop: "Volver a la tienda",
    psAddProducts: "Añada productos para continuar",
    psInclVat: "IVA incl.",
    psBookAppointment: "Reservar cita",
    bkChooseService: "Elija su servicio",
    bkAllOffers: "Todas las ofertas de un vistazo — solo haga clic",
    bkChooseStaff: "Elija un empleado (opcional)",
    bkNoPreference: "Sin preferencia",
    bkNextAvailable: "Próximo empleado disponible",
    bkChooseDateTime: "Elija fecha y hora",
    date: "Fecha",
    time: "Hora",
    bkYourContact: "Sus datos de contacto",
    bkBooked: "¡Cita reservada!",
    bkDetails: "Detalles de la cita",
    bkBookingNumber: "Número de reserva:",
    bkAddToCalendar: "Añadir al calendario",
    bkQuestions: "Para preguntas o cambios, contacte directamente con la tienda.",
    bkNotAvailable: "Reserva de citas no disponible",
    bkNotOffered: "Esta tienda no ofrece actualmente reservas online.",
    bkBookingTitle: "Reserva de cita",
    bkYourSelection: "Su selección",
    bkAcceptTerms: "Al reservar acepta las condiciones de la tienda.",
    bkAnotherAppointment: "Reservar otra cita",
    bkNotesPlaceholder: "Peticiones especiales o notas...",
    coBackToCart: "Volver al carrito",
    coContactData: "Datos de contacto",
    coStreet: "Calle y número *",
    coPayOnDelivery: "Pague al recibir o recoger",
    coThankYou: "¡Gracias por su pedido!",
    coOrderPlaced: "Su pedido se ha realizado correctamente.",
    fpIntro: "Introduzca su correo y le enviaremos un enlace de restablecimiento.",
    fpSending: "Enviando...",
    fpSendLink: "Enviar enlace",
    fpEmailSent: "¡Correo enviado!",
    fpIfAccount: "Si existe una cuenta con",
    fpInfoRest: "recibirá en breve un correo con más instrucciones.",
    fpSpam: "Revise también su carpeta de spam si no recibe el correo.",
    backToLogin: "Volver al inicio de sesión",
    rpValidating: "Verificando el enlace...",
    rpLinkInvalid: "Enlace no válido",
    rpRequestNew: "Solicitar nuevo enlace",
    rpChanged: "¡Contraseña cambiada!",
    rpChangedText: "Su contraseña se ha restablecido. Ya puede iniciar sesión.",
    rpToLogin: "Ir al inicio de sesión",
    rpEnterNew: "Introduzca su nueva contraseña.",
    rpMin8: "Al menos 8 caracteres",
    rpRepeat: "Repita la contraseña",
    rpSaving: "Guardando...",
    rpSave: "Guardar contraseña",
    forSms: "(para SMS)",
    registerWithGoogle: "Registrarse con Google",
    plWelcomeBack: "Bienvenido de nuevo",
    plRegisterNow: "Registrarse ahora",
    plYourPassword: "Su contraseña",
    prOrderHistory: "Historial de pedidos y resumen de citas",
    prStreet: "Calle y número",
    status_new: "Nuevo",
    print: "Imprimir",
    order: "Pedido",
    paymentStatus: "Estado del pago",
    loginWithGoogle: "Iniciar sesión con Google",
    or: "o",
    forgotPassword: "¿Olvidó su contraseña?",
    productsFound: "{count} productos encontrados",
    details: "Detalles",
    free: "Gratis",
    pageOf: "Página {page} de {total}",
    tryOtherSearch: "Pruebe otra búsqueda.",
    productWorlds: "Mundos de productos Panasonic",
    chooseWorld: "Elija su mundo de productos para descubrir la gama adecuada",
    whyPanasonic: "¿Por qué Panasonic?",
    qualityTitle: "Calidad japonesa",
    qualityText: "Los más altos estándares de fabricación y durabilidad para uso profesional",
    toolsTitle: "Herramientas profesionales",
    toolsText: "Desarrolladas especialmente para las necesidades de peluqueros y barberías",
    techTitle: "Tecnología innovadora",
    techText: "Las últimas tecnologías para un trabajo eficiente y los mejores resultados",
    discoverProducts: "Descubrir productos",
    noShopYet: "Aún no ha configurado una tienda para clientes",
    noShopYetText: "Cree su tienda de marca blanca para vender productos Panasonic a sus propios clientes y ofrecer citas online.",
    setupShopNow: "Configurar tienda ahora →",
    chooseArea: "Elija el área de productos deseada.",
    openArea: "Abrir área de productos",
    originalWarranty: "Todos los productos Panasonic son artículos originales de marca con garantía del fabricante.",
    backToWorlds: "Volver a los mundos de productos Panasonic",
    backTo: "Volver a {name}",
    subcategories: "Subcategorías",
    viewProducts: "Ver productos",
    productsInCategory: "Productos en esta categoría",
    clickToViewProducts: "Haga clic aquí para ver todos los productos en \"{name}\".",
    showProducts: "Mostrar productos",
    noCategories: "No hay categorías disponibles.",
    searchProduct: "Buscar producto...",
    back: "Atrás",
    next: "Siguiente",
    allCategories: "Todas las categorías",
    searchProducts: "Buscar productos...",
    showMoreProducts: "Mostrar más productos",
    shownOfProducts: "{shown} de {total} productos mostrados",
    orderedItems: "Artículos pedidos",
    orderNotFound: "Pedido no encontrado",
    b2bTagline: "Venta al por mayor B2B para barberías y peluquerías",
    customerService: "Atención al cliente",
    noNewNotifications: "No hay notificaciones nuevas",
    viewPublicShop: "Ver tienda pública",
    manageShop: "Gestionar mi tienda de clientes",
    noProductsInCategory: "Todavía no hay productos disponibles en esta categoría.",
    home: "Inicio", 
    shop: "Tienda", 
    cart: "Carrito", 
    favorites: "Favoritos", 
    profile: "Perfil",
    orders: "Pedidos",
    admin: "Admin",
    logout: "Cerrar sesión",
    login: "Iniciar sesión",
    register: "Registrarse",
    products: "Productos",
    addToCart: "Añadir al carrito",
    loading: "Cargando...",
    noProducts: "No se encontraron productos",
    addedToFavorites: "Añadido a favoritos",
    removedFromFavorites: "Eliminado de favoritos",
    addedToCart: "Producto añadido al carrito",
    errorLoadingProducts: "Error al cargar productos",
    errorUpdatingFavorites: "Error al actualizar favoritos",
    welcomeBack: "Bienvenido a ED STEEL",
    email: "Correo electrónico",
    password: "Contraseña",
    noAccount: "¿No tienes cuenta?",
    checkout: "Finalizar compra",
    total: "Total",
    shipping: "Envío",
    freeShipping: "Envío gratuito",
    freeShippingFrom: "Envío gratis en pedidos superiores a 200€",
    remainingForFreeShipping: "Faltan {amount} para envío gratuito",
    emptyCart: "Tu carrito está vacío",
    continueShopping: "Continuar comprando",
    orderConfirmation: "Confirmación de pedido",
    orderPlaced: "Pedido realizado",
    payOnDelivery: "Pago contra reembolso",
    onlinePayment: "Pago online",
    placeOrder: "Realizar pedido",
    quantity: "Cantidad",
    price: "Precio",
    priceNet: "Neto",
    priceGross: "Bruto",
    artNr: "Ref.",
    remove: "Eliminar",
    search: "Buscar",
    categories: "Categorías",
    allProducts: "Todos los productos",
    bestsellers: "Más vendidos",
    newArrivals: "Novedades",
    description: "Descripción",
    inStock: "En stock",
    outOfStock: "Agotado",
    orderHistory: "Historial de pedidos",
    orderNumber: "Número de pedido",
    orderDate: "Fecha de pedido",
    orderStatus: "Estado",
    downloadPdf: "Descargar PDF",
    editAddress: "Editar dirección",
    changePassword: "Cambiar contraseña",
    save: "Guardar",
    cancel: "Cancelar",
    status_received: "Recibido",
    status_in_progress: "En proceso",
    status_shipped: "Enviado",
    status_delivered: "Entregado",
    companyName: "Nombre de empresa",
    contactName: "Nombre de contacto",
    phone: "Teléfono",
    address: "Dirección",
    city: "Ciudad",
    postalCode: "Código postal",
    // New keys for translated pages
    noFavorites: "Sin favoritos",
    goToShop: "Ir a la tienda",
    errorLoadingFavorites: "Error al cargar favoritos",
    error: "Error",
    noOrders: "Sin pedidos",
    paid: "Pagado",
    pending: "Pendiente",
    downloadInvoice: "Descargar Factura",
    downloadConfirmation: "Descargar Confirmación",
    shippingAddress: "Dirección de envío",
    paymentMethod: "Método de pago",
    notes: "Notas",
    notesPlaceholder: "Ej: Entregar mañana",
    orderViaWhatsApp: "Pedir por WhatsApp",
    orderSummary: "Resumen del pedido",
    subtotal: "Subtotal",
    processing: "Procesando...",
    orderSuccess: "Pedido realizado con éxito",
    orderFailed: "Pedido fallido",
    heroBanner: "PRODUCTOS PROFESIONALES. PEDIDO RÁPIDO. – Exclusivo para clientes B2B en el sector de barbería.",
    errorLoadingCategories: "Error al cargar categorías",
    contact: "Contacto",
    imprint: "Aviso legal",
    privacy: "Privacidad",
    terms: "Términos",
    cancellation: "Cancelación",
    shippingPayment: "Envío y Pago",
    allRightsReserved: "Todos los derechos reservados.",
    // Login/Register keys
    loginSuccess: "Inicio de sesión exitoso",
    loginFailed: "Inicio de sesión fallido. Verifique sus datos.",
    registerSuccess: "Registro exitoso",
    registerFailed: "Registro fallido. Inténtelo de nuevo.",
    createAccount: "Crea tu cuenta ED STEEL",
    haveAccount: "¿Ya tienes una cuenta?",
    productNotFound: "Producto no encontrado",
    downloadFailed: "Descarga fallida",
    downloadStarted: "Descarga iniciada",
    downloadOrder: "Descargar pedido",
    // Profile page keys
    b2bOnly: "Solo para clientes B2B",
    addressAndContact: "Dirección y Contacto",
    edit: "Editar",
    saving: "Guardando...",
    profileUpdated: "Perfil actualizado con éxito",
    errorSaving: "Error al guardar",
    passwordSection: "Contraseña",
    change: "Cambiar",
    currentPassword: "Contraseña Actual",
    newPassword: "Nueva Contraseña",
    confirmPassword: "Confirmar Nueva Contraseña",
    passwordsNotMatch: "Las contraseñas no coinciden",
    passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
    passwordChanged: "Contraseña cambiada con éxito",
    errorChangingPassword: "Error al cambiar la contraseña",
    viewOrderHistory: "Ver historial de pedidos",
    savedProducts: "Productos guardados",
    legalSection: "Legal"
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  // Initialize from localStorage synchronously so we never overwrite the saved value.
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "de";
    const saved = window.localStorage.getItem("edsteel_lang");
    return saved || "de";
  });

  useEffect(() => {
    localStorage.setItem("edsteel_lang", lang);
    const found = LANGS.find(l => l.code === lang) || LANGS[0];
    document.documentElement.lang = lang;
    document.documentElement.dir = found.dir; // arabisch RTL
  }, [lang]);

  const t = useMemo(() => {
    const pack = DICT[lang] || DICT.de;
    return (key, params) => {
      let s = pack[key] ?? (DICT.de[key] ?? key);
      if (params) {
        Object.entries(params).forEach(([k, v]) => {
          s = s.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
        });
      }
      return s;
    };
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t, LANGS }), [lang, t]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
